import { render } from "./vcorporatetransferadd.vue?vue&type=template&id=675d41ec&scoped=true"
import script from "./vcorporatetransferadd.vue?vue&type=script&lang=js"
export * from "./vcorporatetransferadd.vue?vue&type=script&lang=js"

import "./vcorporatetransferadd.vue?vue&type=style&index=0&id=675d41ec&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675d41ec"]])

export default __exports__